import { DesktopNotificationContext } from './DesktopNotificationProvider.js'
import { useDesktopNotification } from './useDesktopNotification.js'

interface Props {
  children: React.ReactNode
}

export const DesktopNotificationProviderClient = ({ children }: Props) => {
  const value = useDesktopNotification()

  return (
    <DesktopNotificationContext.Provider value={value}>
      {children}
    </DesktopNotificationContext.Provider>
  )
}
